export const ADMIN_LOADING = "ADMIN_LOADING";
export const GET_ADMIN_ONE = "GET_ADMIN_ONE";
export const ADMIN_RESET = "ADMIN_RESET";
export const GET_ADMIN = "GET_ADMIN";
export const GET_ADMIN_SUCCESS = "GET_ADMIN_SUCCESS";
export const GET_ADMIN_FAIL = "GET_ADMIN_FAIL";
export const DELETE_ADMIN = "DELETE_ADMIN"
export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS"
export const DELETE_ADMIN_FAIL = "DELETE_ADMIN_FAIL"
export const UPDATE_ADMIN = "UPDATE_ADMIN"
export const UPDATE_ADMIN_SUCCESS = "UPDATE_ADMIN_SUCCESS"
export const UPDATE_ADMIN_FAIL = "UPDATE_ADMIN_FAIL"
export const ADD_NEW_ADMIN = "ADD_NEW_ADMIN"
export const ADD_ADMIN_SUCCESS = "ADD_ADMIN_SUCCESS"
export const ADD_ADMIN_FAIL = "ADD_ADMIN_FAIL"